import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useTenant } from './useTenant';
import type { TenantConfig } from '@sylva/shared-types';

export type { TenantConfig };

export const useTenantConfig = () => {
  const { currentTenant } = useTenant();

  const { data: config, isLoading, error } = useQuery({
    queryKey: ['tenant-config', currentTenant?.id],
    queryFn: async () => {
      if (!currentTenant) return null;

      const { data, error } = await supabase
        .from('tenant_config')
        .select('*')
        .eq('tenant_id', currentTenant.id)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
    enabled: !!currentTenant,
  });

  // Default to true if config doesn't exist yet (backwards compatible)
  const hasCalendar = config?.sylva_calendar_enabled ?? true;

  return {
    config,
    isLoading,
    error,
    hasCalendar,
  };
};
